import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AssetLibraryPage } from '../features/assets/asset-library-page';
import { assetFilterSearchShape, pickAssetFilters } from '../features/assets/asset-library-state';
const SearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  search: z.string().trim().max(200).optional().catch(undefined),
  view: z.enum(['grid', 'list']).optional().catch(undefined),
  ...assetFilterSearchShape,
});
export const Route = createFileRoute('/manage/$companySlug/assets')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});
function RouteComponent() {
  const { companySlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AssetLibraryPage
      companySlug={companySlug}
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      onSearchChange={(value) =>
        void navigate({
          replace: true,
          search: (previous) => ({ ...previous, page: 1, search: value }),
        })
      }
      filters={pickAssetFilters(search)}
      onFiltersChange={(patch) =>
        void navigate({ replace: true, search: (previous) => ({ ...previous, ...patch, page: 1 }) })
      }
      onViewChange={(view) =>
        void navigate({ replace: true, search: (previous) => ({ ...previous, view }) })
      }
      page={search.page}
      pageSize={search.pageSize}
      search={search.search}
      view={search.view}
    />
  );
}
